import type { IFieldOptions } from '@axo/form/feature/form-input/types';
import { SEQUENCE_REGEX } from '../../../../config/globals';

// https://git.lendme.dk/lendme/customer-interface/-/blob/development/src/app/validators/ValidInput.ts

export const accountNumberFieldOptions = {
  maxLength: 10,
  registerOptions: {
    required: 'error.required',
    minLength: {
      value: 7,
      message: 'AccountNumber.error.length',
    },
    setValueAs: (value) => value.replace(/\s/g, ''),
    validate: (value) => {
      if (SEQUENCE_REGEX.test(value)) {
        return 'AccountNumber.error.pattern';
      }
    },
  },
} satisfies IFieldOptions;
